import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";

export interface Setting {
  setting: unknown;
}

export interface Settings {
  setting: Setting;
}

@Module
export default class SettingsModule extends VuexModule implements Settings {
  setting = {} as Setting;

  @Action
  async [Actions.RETRIEVES_TIMEZONE_LIST]() {
    try {
      const response = await ApiService.post("info/tz", {});
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.RETRIEVES_LOCALE_LIST]() {
    try {
      const response = await ApiService.post("info/locales", {});
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_USER_INFORMATION]() {
    try {
      const response = await ApiService.get("user/me/attributes");
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.UPDATE_USER_BILLING_INFO](data) {
    try {
      const response = await ApiService.put("user/me/attributes", data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_COUNTRY_LIST](params) {
    try {
      const response = await ApiService.get("info/countries" + params);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GET_CITY_LIST]({ countryId, params }) {
    try {
      const response = await ApiService.get(
        `info/country/${countryId}/cities` + params
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
}
